import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Reveal from "../Assets/Reveal";

interface Product {
    _id: string;
    image: string;
    name: string;
}

const demoProducts: Product[] = [
    {
        _id: "Medicinal Products",
        image: "/1/otc1.jpg",
        name: "products.medicinal"

    },
    {
        _id: "CBD Products",
        image: "/1/cbd.jpg",
        name: "products.cbd"

    },
    {
        _id: "Herbal Products",
        image: "/1/herbal_2_50.jpg",
        name: "products.herbal"

    },
    {
        _id: "Dietary Supplements",
        image: "/1/dietary_2_50.jpg",
        name: "products.dietary"

    },
    {
        _id: "Personal Care Products",
        image: "/1/cosmetic_1_50.jpg",
        name: "products.personalCare"

    },

];

interface ProductBoxProps {
    product: Product;
    lang: string;
}

const ProductBox: React.FC<ProductBoxProps> = ({ product }) => {
    const { t } = useTranslation();

    return (
        <Link to={`/parent/${product._id}`} className="group block h-full">
            <div className="relative h-72 rounded-2xl overflow-hidden shadow-md transition-all duration-500 group-hover:shadow-2xl group-hover:-translate-y-1.5">
                {/* Image with zoom on hover */}
                <img
                    src={product.image}
                    alt={`Product ${product._id}`}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                />

                {/* Gradient for text legibility */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent transition-opacity duration-500" />

                {/* Content */}
                <div className="absolute inset-x-0 bottom-0 p-5">
                    <span className="block h-1 w-8 bg-brand-400 rounded-full mb-3 transition-all duration-500 group-hover:w-14" />
                    <h3 className="text-lg sm:text-xl font-semibold text-white drop-shadow-md leading-snug">
                        {t(product.name)}
                    </h3>
                    <div className="flex items-center gap-2 mt-2 text-brand-200 text-sm font-medium opacity-0 -translate-x-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0">
                        <FaArrowRight />
                    </div>
                </div>
            </div>
        </Link>
    );
};

interface ParentProductsProps {
    lang: string;
}

const ParentProducts: React.FC<ParentProductsProps> = ({ lang }) => {
    const { t } = useTranslation(); // Destructure the translation function

    return (
        <section className="py-20 px-4 bg-white">
            <div className="max-w-7xl mx-auto">
                <Reveal>
                    <div className="text-center mb-12">
                        <h1 className="text-3xl sm:text-4xl font-bold text-brand-gray">
                            {t('home.headerParent')} {/* Use the correct translation key */}
                        </h1>
                        <span className="block h-1 w-20 bg-brand-400 rounded-full mx-auto mt-4" />
                    </div>
                </Reveal>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6">
                    {demoProducts.map((product, index) => (
                        <Reveal key={product._id} delay={index * 100} className="h-full">
                            <ProductBox product={product} lang={lang} />
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ParentProducts;
